import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col my-2" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "card-body" }
const _hoisted_7 = { style: {"word-wrap":"break-word","min-height":"120px"} }

import { onMounted, ref, watch } from "vue";
import { blocklyStore } from "../../blockly/blocklyStore";
import CoreDialog from "../../../framework/components/dialog/CoreDialog.vue";
import { templates } from "../../data/templates";
import { templates_dhu } from "../../data/templates_dhu";
import { templates_nttd } from "../../data/templates_nttd";
import { translation } from "../../lang/Translation";
import { DialogHandler } from "./DialogHandler";
import { GlobalImport } from "../../utils/GlobalImport";
import { MessageDialog } from "../../../framework/frontend/MessageDialog";

/**
 * 動的ラベル
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'TemplateDialog',
  setup(__props) {

const t = translation;
const templatePageTitle = t.to("テンプレートを選んではじめよう", "template_title");
const dialogId = DialogHandler.templateDialogId;

/**
 * プロパティ
 */
const list = ref([]);
onMounted(() => {
  DialogHandler.onOpenDialog(dialogId, function () {
    list.value = templates;
  });
});

// 行選択関数
const selectItem = async (item) => {
  if (!item.xml) return;
  const Blockly = GlobalImport.getBlockly();
  const dom = Blockly.Xml.textToDom(item.xml);
  Blockly.Xml.domToWorkspace(dom, blocklyStore.workspace);

  if (item.js_code) {
    blocklyStore.js_code = item.js_code;
  }

  // 保存
  await blocklyStore.save();
  DialogHandler.hideDialog(dialogId);
};
const mode = ref<"preset" | "event">("preset");
const input = ref("");
const onClickPreset = () => {
  mode.value = "preset";
  // console.log("preset")
};

const onClickEvent = () => {
  // console.log("event")
  mode.value = "event";
  input.value = MessageDialog.prompt(
    t.to("イベントコードを入力してください", "template_event_input"),
    ""
  );
};
watch(mode, () => {
  list.value = [];
  if (mode.value === "preset") {
    list.value = templates;
  }
  if (mode.value === "event") {
    if (input.value === "dhu") {
      list.value = templates_dhu;
    }
    if (input.value === "nttd") {
      list.value = templates_nttd;
    }
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CoreDialog, {
    id: _unref(dialogId),
    "dialog-class": { 'modal-xl': true },
    title: _unref(templatePageTitle)
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("button", {
            class: _normalizeClass(["btn me-2", {
            'btn-primary': mode.value === 'preset',
            'btn-outline-primary': !(mode.value === 'preset'),
          }]),
            style: {"width":"15rem"},
            onClick: onClickPreset
          }, _toDisplayString(_unref(t).to("標準", "template_preset")), 3),
          _createElementVNode("button", {
            class: _normalizeClass(["btn", {
            'btn-primary': mode.value === 'event',
            'btn-outline-primary': !(mode.value === 'event'),
          }]),
            style: {"width":"15rem"},
            onClick: onClickEvent
          }, _toDisplayString(_unref(t).to("イベント", "template_event")), 3)
        ])
      ]),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item.title,
            class: "col-md-4"
          }, [
            _createElementVNode("div", {
              class: "card p-0 border-light",
              onClick: ($event: any) => (selectItem(item))
            }, [
              _createElementVNode("img", {
                class: "card-img-top img-responsive",
                style: {"height":"223px","width":"100%","object-fit":"cover"},
                src: item.img,
                onerror: "this.src='../public/list_back_noimage.png'",
                lazyload: ""
              }, null, 8, _hoisted_5),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("h4", null, _toDisplayString(index + 1) + ". " + _toDisplayString(item.title), 1),
                _createElementVNode("p", _hoisted_7, _toDisplayString(item.desc), 1)
              ])
            ], 8, _hoisted_4)
          ]))
        }), 128))
      ])
    ]),
    _: 1
  }, 8, ["id", "title"]))
}
}

})